import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { AppThunkActionType } from '@/store'
import * as httpSettings from '@/config/httpSettings'
import HyStore from '@/utils/storage'
import NCommonSlice = global.NCommonSlice
import NCommonApi = global.NCommonApi

const hyLocalStore = new HyStore(httpSettings.tokenStoragePosition)
const hyLocalRoles = new HyStore(httpSettings.UserRolesKeyPosition)
const hyLocalOffice = new HyStore(httpSettings.UserOfficeKeyPosition)

const initialState: NCommonSlice.ICommonState = {
  userInfo: {}
}

// 这里指定类型是为了让RootStateType更加具体，在写useSelector的时候有代码提示
const commonSlice = createSlice({
  name: 'common',
  initialState,
  reducers: {
    logOut(state, action: PayloadAction<undefined>) {
      state.userInfo = {}
    },
    setUserInfo(state, action: PayloadAction<NCommonApi.UserInfo>) {
      state.userInfo = action.payload
    }
  }
})

export const { logOut, setUserInfo } = commonSlice.actions

// 下面两种函数action的定义方式均可
// export const fetchUser = () => async (dispatch: AppThunkDispatchType) => {}

export const logOutAction = (): AppThunkActionType => async (dispatch) => {
  hyLocalStore.removeItem(httpSettings.tokenStorageKey)
  hyLocalRoles.removeItem(httpSettings.UserRolesKey)
  hyLocalOffice.removeItem(httpSettings.UserHeadOfficeKey)
  dispatch(logOut())
  if (window.location.pathname !== '/custody/login') {
    window.location.href = httpSettings.loginUrl
  }
}

export default commonSlice.reducer
